var numOfSlides = document.querySelectorAll(".swiper-slide").length;

if ((window.innerWidth >= 990 && numOfSlides > 3) || (window.innerWidth >= 750 && numOfSlides > 2) || (window.innerWidth < 750 && numOfSlides > 1)) {
  const swiper = new Swiper('.productSlider', {
      // Optional parameters
      direction: 'horizontal',
      loop: true,
      lazy: true,
      slidesPerView: 1,
      centeredSlides: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true
      },
      breakpoints: {
        750: {
          slidesPerView: 2,
          spaceBetween: 10,
          centeredSlides: false
        },
        1200: {
          slidesPerView: 3,
          spaceBetween: 26,
          centeredSlides: false
        }
      }
  });
} else {
  document.querySelector(".productSlider").classList.add("no-swiper")
  document.querySelector(".productSlider").parentNode.classList.add("no-swiper")
}